import {useState} from 'react';

export const usePagination = () => {
    const [page, setPage] = useState<number>(1);
    const [pages, setPages] = useState<Array<number | string>>([1]);

    return {
        page,
        setPage,
        pages,
        setPages
    }
};